import {
    getOptionsForFeature,
    CalendarHelpOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default function isCalendarHelpSubscriber(): boolean {
    const calendarHelpOptions = getOptionsForFeature<CalendarHelpOptions>(
        OwsOptionsFeatureType.CalendarHelp
    );

    return calendarHelpOptions.calendarHelpEnabled;
}
